
import { useQuery } from "@tanstack/react-query";
import { fetchClassById } from "@/lib/supabase";
import { useSearchParams } from "react-router-dom";

export const useClassDetails = (classId?: string) => {
  // Also check URL parameters directly in case the hook is used without parameters
  const [searchParams] = useSearchParams();
  const classIdFromParams = classId || searchParams.get("classId") || searchParams.get("class") || "";
  
  // Load class details
  const { data: classDetails, isLoading: isClassLoading } = useQuery({
    queryKey: ['class', classIdFromParams],
    queryFn: () => fetchClassById(classIdFromParams),
    enabled: !!classIdFromParams,
  });
  
  // Add debug log to see what we're getting
  console.log("Class details from hook:", { classId: classIdFromParams, classDetails, isClassLoading });
  
  return {
    classDetails,
    isClassLoading
  };
};
